import { ApiClient } from './apiClient';
import { useAuth } from '../context/AuthContext';
import { useMemo } from 'react';

// Hook to get an authenticated API client
export const useApiClient = () => {
  const { getAccessToken } = useAuth();
  
  return useMemo(() => {
    const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080';
    return new ApiClient(API_BASE_URL, getAccessToken);
  }, [getAccessToken]);
};

// Export the base ApiClient class for direct use if needed
export { ApiClient } from './apiClient';